import AcUnitIcon from './assets/ac-unit.svg?react'
import AiColorfulIcon from './assets/ai-colorful.svg?react'
import AliPayIcon from './assets/ali-pay.svg?react'
import AmexCardIcon from './assets/amex-card.svg?react'
import AnnouncementIcon from './assets/announcement.svg?react'
import AppleLogoIcon from './assets/apple-logo.svg?react'
import ApplePayIcon from './assets/apple-pay.svg?react'
import ArrowDownLargeIcon from './assets/arrow-down-large.svg?react'
import ArrowDownSmallIcon from './assets/arrow-down-small.svg?react'
import ArrowLeftLargeIcon from './assets/arrow-left-large.svg?react'
import ArrowLeftSmallIcon from './assets/arrow-left-small.svg?react'
import ArrowRightLargeIcon from './assets/arrow-right-large.svg?react'
import ArrowRightSmallIcon from './assets/arrow-right-small.svg?react'
import ArrowRightXSmallIcon from './assets/arrow-right-xsmall.svg?react'
import ArrowUpLargeIcon from './assets/arrow-up-large.svg?react'
import ArrowUpSmallIcon from './assets/arrow-up-small.svg?react'
import BrandLineType2Icon from './assets/brand-line-type2.svg?react'
import BuygatherLoadingIcon from './assets/buygather-loading.svg?react'
import CalendarIcon from './assets/calendar.svg?react'
import CartFilledIcon from './assets/cart-filled.svg?react'
import CartOutlinedIcon from './assets/cart-outlined.svg?react'
import CashColorfulIcon from './assets/cash-colorful.svg?react'
import CashIcon from './assets/cash.svg?react'
import ChangeBrandIcon from './assets/change-brand.svg?react'
import CheckIcon from './assets/check.svg?react'
import CircleFilledIcon from './assets/circle-filled.svg?react'
import ClockIcon from './assets/clock.svg?react'
import CloseLargeIcon from './assets/close-large.svg?react'
import CloseSmallIcon from './assets/close-small.svg?react'
import ConfettiLeftIcon from './assets/confetti-left.svg?react'
import ConfettiRightIcon from './assets/confetti-right.svg?react'
import CopyIcon from './assets/copy.svg?react'
import Coupon2FilledIcon from './assets/coupon-2-filled.svg?react'
import Coupon2Icon from './assets/coupon-2.svg?react'
import CouponBadgeIcon from './assets/coupon-badge.svg?react'
import CouponColoredIcon from './assets/coupon-red.svg?react'
import CouponIcon from './assets/coupon.svg?react'
import CreditCardIcon from './assets/credit-card.svg?react'
import DotIcon from './assets/dot.svg?react'
import DownloadIcon from './assets/download.svg?react'
import DragIndicatorIcon from './assets/drag-indicator.svg?react'
import DropdownIcon from './assets/dropdown.svg?react'
import EditIcon from './assets/edit.svg?react'
import EnterIcon from './assets/enter.svg?react'
import ErrorFilledIcon from './assets/error-filled.svg?react'
import ErrorOutlinedIcon from './assets/error-outlined.svg?react'
import ExchangeIcon from './assets/exchange.svg?react'
import ExclamationCircleIcon from './assets/exclamation-circle.svg?react'
import FilterIcon from './assets/filter.svg?react'
import FireIcon from './assets/fire.svg?react'
import Fire2Icon from './assets/fire2.svg?react'
import GiftColorful2Icon from './assets/gift-colorful-2.svg?react'
import GiftColorfulIcon from './assets/gift-colorful.svg?react'
import GiftFilledIcon from './assets/gift-filled.svg?react'
import GiftOutlinedIcon from './assets/gift-outlined.svg?react'
import GlobalIcon from './assets/global.svg?react'
import HelpOutlinedIcon from './assets/help-outlined.svg?react'
import HistoryFilled from './assets/history-filled.svg?react'
import HomeIcon from './assets/home.svg?react'
import InfoFilledIcon from './assets/info-filled.svg?react'
import InfoIcon from './assets/info.svg?react'
import JkoPayIcon from './assets/jko-pay.svg?react'
import LightningIcon from './assets/lightning.svg?react'
import LikeFilledIcon from './assets/like-filled.svg?react'
import LikeOutlinedIcon from './assets/like-outlined.svg?react'
import LinePayIcon from './assets/line-pay.svg?react'
import LinkSquareIcon from './assets/link-square.svg?react'
import ListIcon from './assets/list.svg?react'
import LoadingIcon from './assets/loading.svg?react'
import LocationFilledIcon from './assets/location-filled.svg?react'
import LocationOutlinedIcon from './assets/location-outlined.svg?react'
import LockIcon from './assets/lock.svg?react'
import LoveFilledIcon from './assets/love-filled.svg?react'
import LoveOutlinedIcon from './assets/love-outlined.svg?react'
import MailIcon from './assets/mail.svg?react'
import MenuIcon from './assets/menu.svg?react'
import MessageIcon from './assets/message.svg?react'
import MinusIcon from './assets/minus.svg?react'
import MobileIcon from './assets/mobile.svg?react'
import MoneyIcon from './assets/money.svg?react'
import NoImageIcon from './assets/no-image.svg?react'
import NoticeFilledIcon from './assets/notice-filled.svg?react'
import NoticeOutlinedIcon from './assets/notice-outlined.svg?react'
import NotifyFilledIcon from './assets/notify-filled.svg?react'
import NotifyOffFilledIcon from './assets/notify-off-filled.svg?react'
import NotifyOffOutlinedIcon from './assets/notify-off-outlined.svg?react'
import NotifyOutlinedIcon from './assets/notify-outlined.svg?react'
import OpenInNewIcon from './assets/open-in-new.svg?react'
import PackageColorfulIcon from './assets/package-colorful.svg?react'
import PackageOpenedIcon from './assets/package-opened.svg?react'
import PackageIcon from './assets/package.svg?react'
import PasswordSuccessIcon from './assets/password-success.svg?react'
import PayMeIcon from './assets/payme.svg?react'
import PlusIcon from './assets/plus.svg?react'
import PointIcon from './assets/point.svg?react'
import ProductFilledIcon from './assets/product-alt.svg?react'
import QuestionOutlinedIcon from './assets/question-outlined.svg?react'
import RefoundIcon from './assets/refound.svg?react'
import RemindCircleOutlinedIcon from './assets/remind-circle-outlined.svg?react'
import RemindCircleIcon from './assets/remind-circle.svg?react'
import RemindMinusFilledIcon from './assets/remind-minus-filled.svg?react'
import ReturnIcon from './assets/return.svg?react'
import SearchIcon from './assets/search.svg?react'
import ShareReferralIcon from './assets/share-referral.svg?react'
import ShareIcon from './assets/share.svg?react'
import SortFilledIcon from './assets/sort-filled.svg?react'
import SortIcon from './assets/sort.svg?react'
import SpeechBubbleArrowIcon from './assets/speech-bubble-arrow.svg?react'
import StarIcon from './assets/star.svg?react'
import StarburstIcon from './assets/starburst.svg?react'
import SuccessFilledIcon from './assets/success-filled.svg?react'
import SuccessOutlinedIcon from './assets/success-outlined.svg?react'
import TrashFilledIcon from './assets/trash-filled.svg?react'
import TrashOutlinedIcon from './assets/trash-outlined.svg?react'
import TrendingDownIcon from './assets/trending-down.svg?react'
import TrendingUpIcon from './assets/trending-up.svg?react'
import TruckFilledIcon from './assets/truck-filled.svg?react'
import TruckOutlinedIcon2 from './assets/truck-outlined-icon2.svg?react'
import TruckOutlinedIcon from './assets/truck-outlined.svg?react'
import TruckSpeedOutlinedIcon from './assets/truck-speed-outlined.svg?react'
import UploadOutlinedIcon from './assets/upload-outlined.svg?react'
import UserFilledIcon from './assets/user-filled.svg?react'
import UserOutlinedIcon from './assets/user-outlined.svg?react'
import VisibleOffIcon from './assets/visible-off.svg?react'
import VisibleIcon from './assets/visible.svg?react'
import WeChatPayIcon from './assets/wechat-pay.svg?react'
import { GiftIcon } from './components/GiftIcon'
import { createSvgIcon } from './createSvgIcon'
export const AcUnit = createSvgIcon(AcUnitIcon)
export const AliPay = createSvgIcon(AliPayIcon)
export const WeChatPay = createSvgIcon(WeChatPayIcon)
export const PayMe = createSvgIcon(PayMeIcon)
export const AmexCard = createSvgIcon(AmexCardIcon)
export const Announcement = createSvgIcon(AnnouncementIcon)
export const AppleLogo = createSvgIcon(AppleLogoIcon)
export const ApplePay = createSvgIcon(ApplePayIcon)
export const ArrowDownLarge = createSvgIcon(ArrowDownLargeIcon)
export const ArrowDownSmall = createSvgIcon(ArrowDownSmallIcon)
export const ArrowLeftLarge = createSvgIcon(ArrowLeftLargeIcon)
export const ArrowLeftSmall = createSvgIcon(ArrowLeftSmallIcon)
export const ArrowRightLarge = createSvgIcon(ArrowRightLargeIcon)
export const ArrowRightSmall = createSvgIcon(ArrowRightSmallIcon)
export const ArrowRightXSmall = createSvgIcon(ArrowRightXSmallIcon)
export const ArrowUpLarge = createSvgIcon(ArrowUpLargeIcon)
export const ArrowUpSmall = createSvgIcon(ArrowUpSmallIcon)
export const BrandLineType2 = createSvgIcon(BrandLineType2Icon)
export const BuygatherLoading = createSvgIcon(BuygatherLoadingIcon)
export const Calendar = createSvgIcon(CalendarIcon)
export const CartFilled = createSvgIcon(CartFilledIcon)
export const CartOutlined = createSvgIcon(CartOutlinedIcon)
export const Cash = createSvgIcon(CashIcon)
export const ChangeBrand = createSvgIcon(ChangeBrandIcon)
export const Check = createSvgIcon(CheckIcon)
export const CircleFilled = createSvgIcon(CircleFilledIcon)
export const Clock = createSvgIcon(ClockIcon)
export const CloseLarge = createSvgIcon(CloseLargeIcon)
export const CloseSmall = createSvgIcon(CloseSmallIcon)
export const Copy = createSvgIcon(CopyIcon)
export const Coupon = createSvgIcon(CouponIcon)
export const Coupon2 = createSvgIcon(Coupon2Icon)
export const CouponBadge = createSvgIcon(CouponBadgeIcon)
export const CouponColored = createSvgIcon(CouponColoredIcon)
export const Coupon2Filled = createSvgIcon(Coupon2FilledIcon)
export const CreditCard = createSvgIcon(CreditCardIcon)
export const Dot = createSvgIcon(DotIcon)
export const Download = createSvgIcon(DownloadIcon)
export const DragIndicator = createSvgIcon(DragIndicatorIcon)
export const Dropdown = createSvgIcon(DropdownIcon)
export const Edit = createSvgIcon(EditIcon)
export const ErrorFilled = createSvgIcon(ErrorFilledIcon)
export const ErrorOutlined = createSvgIcon(ErrorOutlinedIcon)
export const Exchange = createSvgIcon(ExchangeIcon)
export const Filter = createSvgIcon(FilterIcon)
export const GiftColorful2 = createSvgIcon(GiftColorful2Icon)
export const GiftFilled = createSvgIcon(GiftFilledIcon)
export const GiftOutlined = createSvgIcon(GiftOutlinedIcon)
export const Global = createSvgIcon(GlobalIcon)
export const HelpOutlined = createSvgIcon(HelpOutlinedIcon)
export const History = createSvgIcon(HistoryFilled)
export const Home = createSvgIcon(HomeIcon)
export const Info = createSvgIcon(InfoIcon)
export const InfoFilled = createSvgIcon(InfoFilledIcon)
export const JkoPay = createSvgIcon(JkoPayIcon)
export const LikeFilled = createSvgIcon(LikeFilledIcon)
export const LikeOutlined = createSvgIcon(LikeOutlinedIcon)
export const LinePay = createSvgIcon(LinePayIcon)
export const LinkSquare = createSvgIcon(LinkSquareIcon)
export const Loading = createSvgIcon(LoadingIcon)
export const LocationFilled = createSvgIcon(LocationFilledIcon)
export const LocationOutlined = createSvgIcon(LocationOutlinedIcon)
export const Lock = createSvgIcon(LockIcon)
export const LoveFilled = createSvgIcon(LoveFilledIcon)
export const LoveOutlined = createSvgIcon(LoveOutlinedIcon)
export const Mail = createSvgIcon(MailIcon)
export const Menu = createSvgIcon(MenuIcon)
export const Minus = createSvgIcon(MinusIcon)
export const Mobile = createSvgIcon(MobileIcon)
export const Money = createSvgIcon(MoneyIcon)
export const NoticeFilled = createSvgIcon(NoticeFilledIcon)
export const NoticeOutlined = createSvgIcon(NoticeOutlinedIcon)
export const NotifyFilled = createSvgIcon(NotifyFilledIcon)
export const NotifyOffFilled = createSvgIcon(NotifyOffFilledIcon)
export const NotifyOutlined = createSvgIcon(NotifyOutlinedIcon)
export const NotifyOffOutlined = createSvgIcon(NotifyOffOutlinedIcon)
export const OpenInNew = createSvgIcon(OpenInNewIcon)
export const Package = createSvgIcon(PackageIcon)
export const PackageOpened = createSvgIcon(PackageOpenedIcon)
export const PasswordSuccess = createSvgIcon(PasswordSuccessIcon)
export const Plus = createSvgIcon(PlusIcon)
export const Refound = createSvgIcon(RefoundIcon)
export const RemindCircle = createSvgIcon(RemindCircleIcon)
export const RemindCircleOutlined = createSvgIcon(RemindCircleOutlinedIcon)
export const RemindMinusFilled = createSvgIcon(RemindMinusFilledIcon)
export const Return = createSvgIcon(ReturnIcon)
export const Search = createSvgIcon(SearchIcon)
export const Share = createSvgIcon(ShareIcon)
export const Star = createSvgIcon(StarIcon)
export const Starburst = createSvgIcon(StarburstIcon)
export const SuccessFilled = createSvgIcon(SuccessFilledIcon)
export const SuccessOutlined = createSvgIcon(SuccessOutlinedIcon)
export const TrashFilled = createSvgIcon(TrashFilledIcon)
export const TrashOutlined = createSvgIcon(TrashOutlinedIcon)
export const TruckFilled = createSvgIcon(TruckFilledIcon)
export const TruckOutlined = createSvgIcon(TruckOutlinedIcon)
export const TruckOutlined2 = createSvgIcon(TruckOutlinedIcon2)
export const TrendingDown = createSvgIcon(TrendingDownIcon)
export const TrendingUp = createSvgIcon(TrendingUpIcon)
export const TruckSpeedOutlined = createSvgIcon(TruckSpeedOutlinedIcon)
export const UploadOutlined = createSvgIcon(UploadOutlinedIcon)
export const UserFilled = createSvgIcon(UserFilledIcon)
export const UserOutlined = createSvgIcon(UserOutlinedIcon)
export const Visible = createSvgIcon(VisibleIcon)
export const VisibleOff = createSvgIcon(VisibleOffIcon)
export const Enter = createSvgIcon(EnterIcon)
export const QuestionOutlined = createSvgIcon(QuestionOutlinedIcon)
export const ShareReferral = createSvgIcon(ShareReferralIcon)
/**
 * @deprecated 舊版本，優先使用 Fire2
 */
export const Fire = createSvgIcon(FireIcon)
export const ExclamationCircle = createSvgIcon(ExclamationCircleIcon)
export const AiColorful = createSvgIcon(AiColorfulIcon)
export const Message = createSvgIcon(MessageIcon)
export const ProductFilled = createSvgIcon(ProductFilledIcon)
/** NOTE: 新版的，優先使用 */
export const Fire2 = createSvgIcon(Fire2Icon)
export const Gift = createSvgIcon(GiftIcon)
export const NoImage = createSvgIcon(NoImageIcon)
export const Sort = createSvgIcon(SortIcon)
export const SortFilled = createSvgIcon(SortFilledIcon)
export const List = createSvgIcon(ListIcon)
export const Point = createSvgIcon(PointIcon)
export const ConfettiLeft = createSvgIcon(ConfettiLeftIcon)
export const ConfettiRight = createSvgIcon(ConfettiRightIcon)
export const Lightning = createSvgIcon(LightningIcon)
export const CashColorful = createSvgIcon(CashColorfulIcon)
export const GiftColorful = createSvgIcon(GiftColorfulIcon)
export const PackageColorful = createSvgIcon(PackageColorfulIcon)
export const SpeechBubbleArrow = createSvgIcon(SpeechBubbleArrowIcon)
